import { createAction } from 'redux-actions';
import types from './types';

export const setUserInfo = createAction(types.SET_USER_INFO);
export const setReferralCode = createAction(types.SET_REFERRAL_CODE);
export const verifyEmailSuccess = createAction(types.VERIFY_EMAIL_SUCCESS);
export const verifyCampusEmailSuccess = createAction(types.VERIFY_CAMPUS_EMAIL_SUCCESS);
export const setReferralRequired = createAction(types.SET_REFERRAL_REQUIRED);
export const setOnboardingStatus = createAction(types.SET_ONBOARDING_STATUS);
